import { ReadonlyURLSearchParams } from 'next/navigation'

type ParamValue = string | Array<string> | undefined
type Params = Record<string, ParamValue>

function getStringRouteParam<Key extends string>(
  params: ReadonlyURLSearchParams | Params,
  key: Key,
): string | undefined {
  if (params instanceof ReadonlyURLSearchParams) {
    const param = params.get(key)

    return param || undefined // Prevent empty string
  }

  const param = (params as Params)[key]

  // Prevent non-string values (arrays)
  if (typeof param !== 'string') {
    return undefined
  }

  return param || undefined // Prevent empty string
}

export default getStringRouteParam
